import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MinuteRequestApprovalRuleService } from '../../services/minute-request-approval-rule.service';
import { RolesService } from 'src/app/pages/inner-security/services/roles.service';
import { RoleToAssignToMinuteApprovalRule, UpdateMinuteRequestApprovalRuleDTO, UpdateMinuteRequestApprovalRuleViewModel } from '../../interfaces/minute-request-approval-rule-manage.interface';
import { map, Observable } from 'rxjs';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-update-minute-request-approval-rule',
  templateUrl: './update-minute-request-approval-rule.component.html',
  styleUrl: './update-minute-request-approval-rule.component.scss'
})
export class UpdateMinuteRequestApprovalRuleComponent implements OnInit{

  public rolesToAssign$: Observable<RoleToAssignToMinuteApprovalRule[]>;

  public updateRuleForm: FormGroup;

  constructor(private dialogRef: MatDialogRef<UpdateMinuteRequestApprovalRuleComponent>,
    @Inject(MAT_DIALOG_DATA)public data: UpdateMinuteRequestApprovalRuleViewModel,
    private fb: FormBuilder,
    private minuteRequestApprovalRuleService: MinuteRequestApprovalRuleService,
    private rolesService: RolesService
  ){
    this.updateRuleForm = this.fb.group({
      name: [{value: data.name, disabled: true}],
      description: [data.description],
      minApprovalRequired: [data.minApprovalRequired, Validators.required ],
      priority: [data.priority, Validators.required ],
      roles: [data.roles, Validators.required ]
    });

  }
  ngOnInit(): void {
    this.getRolesToAssign();
  }

  public clickCloseDialog(){
    this.dialogRef.close(false);
  }

  public getRolesToAssign(){
    this.rolesToAssign$ = this.rolesService.getAllRoles()
    .pipe(
      map((roles) => {
        return roles.map(r => <RoleToAssignToMinuteApprovalRule>{
          roleId: r.roleId,
          name: r.name
        });
      })
    )
  }

  public submitUpdate() {
    const { description, priority, minApprovalRequired, roles } = this.updateRuleForm.value;
    const request: UpdateMinuteRequestApprovalRuleDTO = {
      description: description,
      minApprovalRequired: minApprovalRequired,
      priority: priority,
      roles: roles
    };
    const updateRequest$ = this.minuteRequestApprovalRuleService.updateMinuteRequestApprovalRule(this.data.minuteRequestApprovalRuleId, request);
    
    Swal.fire({
      title: 'Modificando regla de aprobación',
      didOpen: () => {
        Swal.showLoading();
        updateRequest$.subscribe({
          next: (res) => {
            Swal.fire({
              icon: 'success',
              title: res.resultMessage,
              didClose: () => {
                this.dialogRef.close(true);
              }
            });
          },
          error: (err) => {
            Swal.fire({
              icon: 'error',
              title: err.error.message
            });
          }
        })
      }
    })
  }

}
